/**
 * The curated MUI-backed icon registry — the ONLY place `@mui/icons-material` may be imported. Each
 * export is one canonical icon per meaning: near-duplicate MUI variants collapse onto a single export,
 * so consumers never choose a variant. To add an icon, add ONE line (import + `createIcon`); never
 * re-add a variant that already has a canonical export.
 */
import MuiAccessTime from "@mui/icons-material/AccessTime";
import MuiAdd from "@mui/icons-material/Add";
import MuiAddCircle from "@mui/icons-material/AddCircle";
import MuiArrowBack from "@mui/icons-material/ArrowBack";
import MuiArrowDropDown from "@mui/icons-material/ArrowDropDown";
import MuiArrowForward from "@mui/icons-material/ArrowForward";
import MuiArrowLeft from "@mui/icons-material/ArrowLeft";
import MuiArrowRight from "@mui/icons-material/ArrowRight";
import MuiArrowRightAlt from "@mui/icons-material/ArrowRightAlt";
import MuiAssignment from "@mui/icons-material/Assignment";
import MuiAutoAwesomeOutlined from "@mui/icons-material/AutoAwesomeOutlined";
import MuiAutorenew from "@mui/icons-material/Autorenew";
import MuiBlock from "@mui/icons-material/Block";
import MuiCancel from "@mui/icons-material/Cancel";
import MuiCancelScheduleSend from "@mui/icons-material/CancelScheduleSend";
import MuiCheck from "@mui/icons-material/Check";
import MuiCheckCircle from "@mui/icons-material/CheckCircle";
import MuiCheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import MuiChevronLeft from "@mui/icons-material/ChevronLeft";
import MuiChevronRight from "@mui/icons-material/ChevronRight";
import MuiCircle from "@mui/icons-material/Circle";
import MuiClose from "@mui/icons-material/Close";
import MuiCloseFullscreen from "@mui/icons-material/CloseFullscreen";
import MuiCloudDownloadOutlined from "@mui/icons-material/CloudDownloadOutlined";
import MuiCode from "@mui/icons-material/Code";
import MuiCommentOutlined from "@mui/icons-material/CommentOutlined";
import MuiContentCopy from "@mui/icons-material/ContentCopy";
import MuiCopyright from "@mui/icons-material/Copyright";
import MuiDangerousOutlined from "@mui/icons-material/DangerousOutlined";
import MuiDarkMode from "@mui/icons-material/DarkMode";
import MuiDeleteForever from "@mui/icons-material/DeleteForever";
import MuiDeleteOutline from "@mui/icons-material/DeleteOutline";
import MuiDescription from "@mui/icons-material/Description";
import MuiDriveFileMove from "@mui/icons-material/DriveFileMove";
import MuiEdit from "@mui/icons-material/Edit";
import MuiEmojiObjects from "@mui/icons-material/EmojiObjects";
import MuiError from "@mui/icons-material/Error";
import MuiFileDownloadOutlined from "@mui/icons-material/FileDownloadOutlined";
import MuiFileUploadOutlined from "@mui/icons-material/FileUploadOutlined";
import MuiFolderOutlined from "@mui/icons-material/FolderOutlined";
import MuiFormatBold from "@mui/icons-material/FormatBold";
import MuiFormatItalic from "@mui/icons-material/FormatItalic";
import MuiFormatListBulleted from "@mui/icons-material/FormatListBulleted";
import MuiFormatListNumbered from "@mui/icons-material/FormatListNumbered";
import MuiFormatQuote from "@mui/icons-material/FormatQuote";
import MuiFullscreen from "@mui/icons-material/Fullscreen";
import MuiGroupsOutlined from "@mui/icons-material/GroupsOutlined";
import MuiHealing from "@mui/icons-material/Healing";
import MuiHelpOutline from "@mui/icons-material/HelpOutline";
import MuiHighlightOff from "@mui/icons-material/HighlightOff";
import MuiInfoOutlined from "@mui/icons-material/InfoOutlined";
import MuiInsertDriveFileOutlined from "@mui/icons-material/InsertDriveFileOutlined";
import MuiInventory from "@mui/icons-material/Inventory";
import MuiKeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import MuiKeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import MuiKeyOutlined from "@mui/icons-material/KeyOutlined";
import MuiLightMode from "@mui/icons-material/LightMode";
import MuiLink from "@mui/icons-material/Link";
import MuiLinkOff from "@mui/icons-material/LinkOff";
import MuiLockOutlined from "@mui/icons-material/LockOutlined";
import MuiLockReset from "@mui/icons-material/LockReset";
import MuiMenuBook from "@mui/icons-material/MenuBook";
import MuiMoreVert from "@mui/icons-material/MoreVert";
import MuiNearMeOutlined from "@mui/icons-material/NearMeOutlined";
import MuiNotificationsActive from "@mui/icons-material/NotificationsActive";
import MuiPendingActions from "@mui/icons-material/PendingActions";
import MuiPlaylistAdd from "@mui/icons-material/PlaylistAdd";
import MuiReceiptLongOutlined from "@mui/icons-material/ReceiptLongOutlined";
import MuiRedo from "@mui/icons-material/Redo";
import MuiRefresh from "@mui/icons-material/Refresh";
import MuiRemoveCircleOutline from "@mui/icons-material/RemoveCircleOutline";
import MuiReplay from "@mui/icons-material/Replay";
import MuiRestartAlt from "@mui/icons-material/RestartAlt";
import MuiRocketLaunch from "@mui/icons-material/RocketLaunch";
import MuiSave from "@mui/icons-material/Save";
import MuiScheduleOutlined from "@mui/icons-material/ScheduleOutlined";
import MuiSearch from "@mui/icons-material/Search";
import MuiSend from "@mui/icons-material/Send";
import MuiSettings from "@mui/icons-material/Settings";
import MuiSettingsBackupRestore from "@mui/icons-material/SettingsBackupRestore";
import MuiShieldOutlined from "@mui/icons-material/ShieldOutlined";
import MuiSpeedOutlined from "@mui/icons-material/SpeedOutlined";
import MuiSquare from "@mui/icons-material/Square";
import MuiSwapHoriz from "@mui/icons-material/SwapHoriz";
import MuiTerminalOutlined from "@mui/icons-material/TerminalOutlined";
import MuiThumbDown from "@mui/icons-material/ThumbDown";
import MuiThumbDownOutlined from "@mui/icons-material/ThumbDownOutlined";
import MuiThumbUp from "@mui/icons-material/ThumbUp";
import MuiThumbUpOutlined from "@mui/icons-material/ThumbUpOutlined";
import MuiTitle from "@mui/icons-material/Title";
import MuiUndo from "@mui/icons-material/Undo";
import MuiVerifiedUserOutlined from "@mui/icons-material/VerifiedUserOutlined";
import MuiVerticalSplit from "@mui/icons-material/VerticalSplit";
import MuiVisibility from "@mui/icons-material/Visibility";
import MuiVisibilityOff from "@mui/icons-material/VisibilityOff";
import MuiWarning from "@mui/icons-material/Warning";
import MuiWarningAmber from "@mui/icons-material/WarningAmber";
import MuiWrapText from "@mui/icons-material/WrapText";
import { createIcon } from "./IconBase";
export const AccessTimeIcon = createIcon(MuiAccessTime, "AccessTimeIcon");
export const AddIcon = createIcon(MuiAdd, "AddIcon");
export const AddCircleIcon = createIcon(MuiAddCircle, "AddCircleIcon");
export const ArrowLeftIcon = createIcon(MuiArrowBack, "ArrowLeftIcon");
export const ArrowDropDownIcon = createIcon(MuiArrowDropDown, "ArrowDropDownIcon");
export const ArrowRightIcon = createIcon(MuiArrowForward, "ArrowRightIcon");
export const CaretLeftIcon = createIcon(MuiArrowLeft, "CaretLeftIcon");
export const CaretRightIcon = createIcon(MuiArrowRight, "CaretRightIcon");
export const ArrowLongRightIcon = createIcon(MuiArrowRightAlt, "ArrowLongRightIcon");
export const AssignmentIcon = createIcon(MuiAssignment, "AssignmentIcon");
export const AutoAwesomeIcon = createIcon(MuiAutoAwesomeOutlined, "AutoAwesomeIcon");
export const AutorenewIcon = createIcon(MuiAutorenew, "AutorenewIcon");
export const BlockIcon = createIcon(MuiBlock, "BlockIcon");
export const CancelIcon = createIcon(MuiCancel, "CancelIcon");
export const CancelScheduleSendIcon = createIcon(MuiCancelScheduleSend, "CancelScheduleSendIcon");
export const CheckIcon = createIcon(MuiCheck, "CheckIcon");
export const CheckCircleIcon = createIcon(MuiCheckCircle, "CheckCircleIcon");
export const CheckCircleOutlineIcon = createIcon(MuiCheckCircleOutline, "CheckCircleOutlineIcon");
export const ChevronLeftIcon = createIcon(MuiChevronLeft, "ChevronLeftIcon");
export const ChevronRightIcon = createIcon(MuiChevronRight, "ChevronRightIcon");
export const CircleIcon = createIcon(MuiCircle, "CircleIcon");
export const CloseIcon = createIcon(MuiClose, "CloseIcon");
export const CloseFullscreenIcon = createIcon(MuiCloseFullscreen, "CloseFullscreenIcon");
export const CloudDownloadIcon = createIcon(MuiCloudDownloadOutlined, "CloudDownloadIcon");
export const LinkOffIcon = createIcon(MuiLinkOff, "LinkOffIcon");
export const CodeIcon = createIcon(MuiCode, "CodeIcon");
export const CommentIcon = createIcon(MuiCommentOutlined, "CommentIcon");
export const ContentCopyIcon = createIcon(MuiContentCopy, "ContentCopyIcon");
export const CopyrightIcon = createIcon(MuiCopyright, "CopyrightIcon");
export const DangerousIcon = createIcon(MuiDangerousOutlined, "DangerousIcon");
export const DarkModeIcon = createIcon(MuiDarkMode, "DarkModeIcon");
export const DeleteForeverIcon = createIcon(MuiDeleteForever, "DeleteForeverIcon");
export const DeleteIcon = createIcon(MuiDeleteOutline, "DeleteIcon");
export const DescriptionIcon = createIcon(MuiDescription, "DescriptionIcon");
export const MoveFileIcon = createIcon(MuiDriveFileMove, "MoveFileIcon");
export const EditIcon = createIcon(MuiEdit, "EditIcon");
export const LightbulbIcon = createIcon(MuiEmojiObjects, "LightbulbIcon");
export const ErrorIcon = createIcon(MuiError, "ErrorIcon");
export const DownloadIcon = createIcon(MuiFileDownloadOutlined, "DownloadIcon");
export const UploadIcon = createIcon(MuiFileUploadOutlined, "UploadIcon");
export const FolderIcon = createIcon(MuiFolderOutlined, "FolderIcon");
export const FormatBoldIcon = createIcon(MuiFormatBold, "FormatBoldIcon");
export const FormatItalicIcon = createIcon(MuiFormatItalic, "FormatItalicIcon");
export const FormatListBulletedIcon = createIcon(MuiFormatListBulleted, "FormatListBulletedIcon");
export const FormatListNumberedIcon = createIcon(MuiFormatListNumbered, "FormatListNumberedIcon");
export const FormatQuoteIcon = createIcon(MuiFormatQuote, "FormatQuoteIcon");
export const FullscreenIcon = createIcon(MuiFullscreen, "FullscreenIcon");
export const GroupsIcon = createIcon(MuiGroupsOutlined, "GroupsIcon");
export const HealingIcon = createIcon(MuiHealing, "HealingIcon");
export const HelpIcon = createIcon(MuiHelpOutline, "HelpIcon");
export const HighlightOffIcon = createIcon(MuiHighlightOff, "HighlightOffIcon");
export const InfoIcon = createIcon(MuiInfoOutlined, "InfoIcon");
export const FileIcon = createIcon(MuiInsertDriveFileOutlined, "FileIcon");
export const InventoryIcon = createIcon(MuiInventory, "InventoryIcon");
export const ChevronDownIcon = createIcon(MuiKeyboardArrowDown, "ChevronDownIcon");
export const ChevronUpIcon = createIcon(MuiKeyboardArrowUp, "ChevronUpIcon");
export const KeyIcon = createIcon(MuiKeyOutlined, "KeyIcon");
export const LightModeIcon = createIcon(MuiLightMode, "LightModeIcon");
export const LinkIcon = createIcon(MuiLink, "LinkIcon");
export const LockIcon = createIcon(MuiLockOutlined, "LockIcon");
export const LockResetIcon = createIcon(MuiLockReset, "LockResetIcon");
export const MenuBookIcon = createIcon(MuiMenuBook, "MenuBookIcon");
export const MoreVertIcon = createIcon(MuiMoreVert, "MoreVertIcon");
export const NearMeIcon = createIcon(MuiNearMeOutlined, "NearMeIcon");
export const NotificationsActiveIcon = createIcon(MuiNotificationsActive, "NotificationsActiveIcon");
export const PendingActionsIcon = createIcon(MuiPendingActions, "PendingActionsIcon");
export const PlaylistAddIcon = createIcon(MuiPlaylistAdd, "PlaylistAddIcon");
export const ReceiptLongIcon = createIcon(MuiReceiptLongOutlined, "ReceiptLongIcon");
export const RedoIcon = createIcon(MuiRedo, "RedoIcon");
export const RefreshIcon = createIcon(MuiRefresh, "RefreshIcon");
export const RemoveCircleIcon = createIcon(MuiRemoveCircleOutline, "RemoveCircleIcon");
export const ReplayIcon = createIcon(MuiReplay, "ReplayIcon");
export const RestartAltIcon = createIcon(MuiRestartAlt, "RestartAltIcon");
export const RocketLaunchIcon = createIcon(MuiRocketLaunch, "RocketLaunchIcon");
export const SaveIcon = createIcon(MuiSave, "SaveIcon");
export const ScheduleIcon = createIcon(MuiScheduleOutlined, "ScheduleIcon");
export const SearchIcon = createIcon(MuiSearch, "SearchIcon");
export const SendIcon = createIcon(MuiSend, "SendIcon");
export const SettingsIcon = createIcon(MuiSettings, "SettingsIcon");
export const RestoreIcon = createIcon(MuiSettingsBackupRestore, "RestoreIcon");
export const ShieldIcon = createIcon(MuiShieldOutlined, "ShieldIcon");
export const SpeedIcon = createIcon(MuiSpeedOutlined, "SpeedIcon");
export const SquareIcon = createIcon(MuiSquare, "SquareIcon");
export const SwapHorizIcon = createIcon(MuiSwapHoriz, "SwapHorizIcon");
export const TerminalIcon = createIcon(MuiTerminalOutlined, "TerminalIcon");
export const ThumbDownIcon = createIcon(MuiThumbDown, "ThumbDownIcon");
export const ThumbDownOutlineIcon = createIcon(MuiThumbDownOutlined, "ThumbDownOutlineIcon");
export const ThumbUpIcon = createIcon(MuiThumbUp, "ThumbUpIcon");
export const ThumbUpOutlineIcon = createIcon(MuiThumbUpOutlined, "ThumbUpOutlineIcon");
export const TitleIcon = createIcon(MuiTitle, "TitleIcon");
export const UndoIcon = createIcon(MuiUndo, "UndoIcon");
export const VerifiedUserIcon = createIcon(MuiVerifiedUserOutlined, "VerifiedUserIcon");
export const VerticalSplitIcon = createIcon(MuiVerticalSplit, "VerticalSplitIcon");
export const VisibilityIcon = createIcon(MuiVisibility, "VisibilityIcon");
export const VisibilityOffIcon = createIcon(MuiVisibilityOff, "VisibilityOffIcon");
export const WarningIcon = createIcon(MuiWarning, "WarningIcon");
export const WarningOutlineIcon = createIcon(MuiWarningAmber, "WarningOutlineIcon");
export const WrapTextIcon = createIcon(MuiWrapText, "WrapTextIcon");
//# sourceMappingURL=material.js.map